// src/components/DocsSidebar.jsx
import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Link,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material';
import BookmarksIcon from '@mui/icons-material/Bookmarks';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useLocation } from 'react-router-dom';
import commandsNav from 'data/commandsNav';

const categoryMap = {
  game: '미니게임',
  overwatch: '오버워치',
  tarkov: '타르코프',
  meal: '급식',
  custom: '커스텀 봇',
  etc: '기타',
};

const DocsSidebar = () => {
  const location = useLocation();

  // ✅ 현재 경로 → 카테고리 한글로 변환
  const getCategoryFromPath = (pathname) => {
    const segment = pathname.split('/')[2];
    return categoryMap[segment] || '';
  };

  const currentCategory = getCategoryFromPath(location.pathname);
  const [expanded, setExpanded] = useState(currentCategory);

  // ✅ 경로 바뀌면 자동으로 펼치기
  useEffect(() => {
    setExpanded(currentCategory);
  }, [location.pathname]);

  const handleAccordionChange = (label) => {
    setExpanded((prev) => (prev === label ? '' : label));
  };

  return (
    <Box
  sx={{
    width: '100%',
    maxWidth: {xs:'none',sm:'none',md:300},  
    px: {xs:0,sm:2,md:2}, 
    boxSizing: 'border-box',
  }}
>
      

      {commandsNav.map((section) => (
        <Accordion
          key={section.label}
          expanded={expanded === section.label}
          onChange={() => handleAccordionChange(section.label)}
          disableGutters
          elevation={0}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography fontWeight="bold" variant="subtitle1" sx={{fontSize: {xs:'1.2rem' ,sm:'1.2rem' ,md:'0.95rem' }}}>
              {section.label}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            {section.children.map((item) => (
              <Link
                key={item.path}
                href={item.path}
                underline="hover"
                color={location.pathname === item.path ? 'primary' : 'inherit'}
                sx={{ display: 'block', ml: 0, my: 0.5, fontSize:  {xs:'1.2rem' ,sm:'1.2rem' ,md:'0.95rem' }}}
              >
                {item.label}
              </Link>
            ))}
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
};

export default DocsSidebar;
